export function convertKeyValuePairToMap<TValue>(keyValuePair: { [key: string]: TValue }): Map<string, TValue> {
    const map = new Map<string, TValue>();
    Object.entries(keyValuePair).forEach(([key, value]) => {
        map.set(key, value);
    });
    return map;
}
